<div class="scraii-ai-filter-row" style="display: none;">
        <span class="scraii-ai-filter-row-label pe-2">Selected Filter</span>
        <span class="scraii-ai-filter-row-value">All brands</span>
        <mat-icon class="scraii-ai-filter-row-check">check_circle</mat-icon>
        <button class="scraii-ai-filter-add-btn">
            <mat-icon class="scraii-ai-filter-add-icon">add</mat-icon>
            Add filter
        </button>
</div>
<div class="position-relative" [ngClass]="[isExpanded ? 'scraii-ai-chat-wrapper' : 'scraii-ai-chat-wrapper-collapsed', isFloatingView ? 'is-floating-view' : '', isFloatingView && isFloatingExpanded ? 'is-floating-expanded' : '']">

    <!-- Shared ag-grid for RAG citations and contract_rag inline tables -->
    <ng-template #ragAgGrid let-rowData="rowData" let-columnDefs="columnDefs" let-gridKey="gridKey">
        <div class="scraii-ai-rag-citation-scroll scraii-ai-rag-grid-wrapper">
            <ag-grid-angular
                class="ag-theme-balham scraii-ai-rag-ag-grid"
                style="width: 100%; height: auto;"
                [domLayout]="ragGridDomLayout"
                [rowData]="rowData"
                [columnDefs]="columnDefs ?? emptyRagGridColumns"
                [defaultColDef]="ragGridDefaultColDef"
                [headerHeight]="40"
                [pagination]="true"
                [paginationPageSize]="ragGridPageSize"
                [animateRows]="false"
                [suppressCellFocus]="true"
                [suppressClickEdit]="true"
                [suppressRowClickSelection]="true"
                [enableCellTextSelection]="true"
                [enableBrowserTooltips]="true"
                (gridReady)="onRagGridReady(gridKey, $event)">
            </ag-grid-angular>
        </div>
    </ng-template>

    <!-- Static filter row — placeholder for future filter UI, disabled/non-interactive -->
    <!-- <div class="scraii-ai-filter-row">
        <span class="scraii-ai-filter-row-label">Selected Filter</span>
        <span class="scraii-ai-filter-row-value">All brands</span>
        <mat-icon class="scraii-ai-filter-row-check">check_circle</mat-icon>
        <button class="scraii-ai-filter-add-btn" disabled>
            <mat-icon class="scraii-ai-filter-add-icon">add</mat-icon>
            Add filter
        </button>
    </div> -->

    <!-- Sidebar -->
    <!-- Commented out the sidebar for now -->
    <!-- <span class="scraii-ai-sidebar-chat-icon" (click)="toggleAiChats()" *ngIf="!isExpanded">
        <svg width="30" height="30" viewBox="0 0 20 20" fill="#6a707e" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.83496 3.99992C6.38353 4.00411 6.01421 4.0122 5.69824 4.03801C5.31232 4.06954 5.03904 4.12266 4.82227 4.20012L4.62207 4.28606C4.18264 4.50996 3.81498 4.85035 3.55859 5.26848L3.45605 5.45207C3.33013 5.69922 3.25006 6.01354 3.20801 6.52824C3.16533 7.05065 3.16504 7.71885 3.16504 8.66301V11.3271C3.16504 12.2712 3.16533 12.9394 3.20801 13.4618C3.25006 13.9766 3.33013 14.2909 3.45605 14.538L3.55859 14.7216C3.81498 15.1397 4.18266 15.4801 4.62207 15.704L4.82227 15.79C5.03904 15.8674 5.31234 15.9205 5.69824 15.9521C6.01398 15.9779 6.383 15.986 6.83398 15.9902L6.83496 3.99992ZM18.165 11.3271C18.165 12.2493 18.1653 12.9811 18.1172 13.5702C18.0745 14.0924 17.9916 14.5472 17.8125 14.9648L17.7295 15.1415C17.394 15.8 16.8834 16.3511 16.2568 16.7353L15.9814 16.8896C15.5157 17.1268 15.0069 17.2285 14.4102 17.2773C13.821 17.3254 13.0893 17.3251 12.167 17.3251H7.83301C6.91071 17.3251 6.17898 17.3254 5.58984 17.2773C5.06757 17.2346 4.61294 17.1508 4.19531 16.9716L4.01855 16.8896C3.36014 16.5541 2.80898 16.0434 2.4248 15.4169L2.27051 15.1415C2.03328 14.6758 1.93158 14.167 1.88281 13.5702C1.83468 12.9811 1.83496 12.2493 1.83496 11.3271V8.66301C1.83496 7.74072 1.83468 7.00898 1.88281 6.41985C1.93157 5.82309 2.03329 5.31432 2.27051 4.84856L2.4248 4.57317C2.80898 3.94666 3.36012 3.436 4.01855 3.10051L4.19531 3.0175C4.61285 2.83843 5.06771 2.75548 5.58984 2.71281C6.17898 2.66468 6.91071 2.66496 7.83301 2.66496H12.167C13.0893 2.66496 13.821 2.66468 14.4102 2.71281C15.0069 2.76157 15.5157 2.86329 15.9814 3.10051L16.2568 3.25481C16.8833 3.63898 17.394 4.19012 17.7295 4.84856L17.8125 5.02531C17.9916 5.44285 18.0745 5.89771 18.1172 6.41985C18.1653 7.00898 18.165 7.74072 18.165 8.66301V11.3271ZM8.16406 15.995H12.167C13.1112 15.995 13.7794 15.9947 14.3018 15.9521C14.8164 15.91 15.1308 15.8299 15.3779 15.704L15.5615 15.6015C15.9797 15.3451 16.32 14.9774 16.5439 14.538L16.6299 14.3378C16.7074 14.121 16.7605 13.8478 16.792 13.4618C16.8347 12.9394 16.835 12.2712 16.835 11.3271V8.66301C16.835 7.71885 16.8347 7.05065 16.792 6.52824C16.7605 6.14232 16.7073 5.86904 16.6299 5.65227L16.5439 5.45207C16.32 5.01264 15.9796 4.64498 15.5615 4.3886L15.3779 4.28606C15.1308 4.16013 14.8165 4.08006 14.3018 4.03801C13.7794 3.99533 13.1112 3.99504 12.167 3.99504H8.16406C8.16407 3.99667 8.16504 3.99829 8.16504 3.99992L8.16406 15.995Z" />
        </svg>
    </span> -->
    <!-- Main Content Area -->
    <div class="scraii-ai-main-content">
        <!-- Filter row (top bar): "Selected Filter" label + brand multiselect dropdown -->
        <div class="scraii-ai-filter-row" *ngIf="!isFloatingView">
            <span class="d-flex align-items-center gap-2">
                <span class="scraii-ai-sidebar-chat-icon-inside" (click)="toggleAiChats()" *ngIf="!isExpanded">
                    <svg width="30" height="30" viewBox="0 0 20 20" fill="#6a707e" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.83496 3.99992C6.38353 4.00411 6.01421 4.0122 5.69824 4.03801C5.31232 4.06954 5.03904 4.12266 4.82227 4.20012L4.62207 4.28606C4.18264 4.50996 3.81498 4.85035 3.55859 5.26848L3.45605 5.45207C3.33013 5.69922 3.25006 6.01354 3.20801 6.52824C3.16533 7.05065 3.16504 7.71885 3.16504 8.66301V11.3271C3.16504 12.2712 3.16533 12.9394 3.20801 13.4618C3.25006 13.9766 3.33013 14.2909 3.45605 14.538L3.55859 14.7216C3.81498 15.1397 4.18266 15.4801 4.62207 15.704L4.82227 15.79C5.03904 15.8674 5.31234 15.9205 5.69824 15.9521C6.01398 15.9779 6.383 15.986 6.83398 15.9902L6.83496 3.99992ZM18.165 11.3271C18.165 12.2493 18.1653 12.9811 18.1172 13.5702C18.0745 14.0924 17.9916 14.5472 17.8125 14.9648L17.7295 15.1415C17.394 15.8 16.8834 16.3511 16.2568 16.7353L15.9814 16.8896C15.5157 17.1268 15.0069 17.2285 14.4102 17.2773C13.821 17.3254 13.0893 17.3251 12.167 17.3251H7.83301C6.91071 17.3251 6.17898 17.3254 5.58984 17.2773C5.06757 17.2346 4.61294 17.1508 4.19531 16.9716L4.01855 16.8896C3.36014 16.5541 2.80898 16.0434 2.4248 15.4169L2.27051 15.1415C2.03328 14.6758 1.93158 14.167 1.88281 13.5702C1.83468 12.9811 1.83496 12.2493 1.83496 11.3271V8.66301C1.83496 7.74072 1.83468 7.00898 1.88281 6.41985C1.93157 5.82309 2.03329 5.31432 2.27051 4.84856L2.4248 4.57317C2.80898 3.94666 3.36012 3.436 4.01855 3.10051L4.19531 3.0175C4.61285 2.83843 5.06771 2.75548 5.58984 2.71281C6.17898 2.66468 6.91071 2.66496 7.83301 2.66496H12.167C13.0893 2.66496 13.821 2.66468 14.4102 2.71281C15.0069 2.76157 15.5157 2.86329 15.9814 3.10051L16.2568 3.25481C16.8833 3.63898 17.394 4.19012 17.7295 4.84856L17.8125 5.02531C17.9916 5.44285 18.0745 5.89771 18.1172 6.41985C18.1653 7.00898 18.165 7.74072 18.165 8.66301V11.3271ZM8.16406 15.995H12.167C13.1112 15.995 13.7794 15.9947 14.3018 15.9521C14.8164 15.91 15.1308 15.8299 15.3779 15.704L15.5615 15.6015C15.9797 15.3451 16.32 14.9774 16.5439 14.538L16.6299 14.3378C16.7074 14.121 16.7605 13.8478 16.792 13.4618C16.8347 12.9394 16.835 12.2712 16.835 11.3271V8.66301C16.835 7.71885 16.8347 7.05065 16.792 6.52824C16.7605 6.14232 16.7073 5.86904 16.6299 5.65227L16.5439 5.45207C16.32 5.01264 15.9796 4.64498 15.5615 4.3886L15.3779 4.28606C15.1308 4.16013 14.8165 4.08006 14.3018 4.03801C13.7794 3.99533 13.1112 3.99504 12.167 3.99504H8.16406C8.16407 3.99667 8.16504 3.99829 8.16504 3.99992L8.16406 15.995Z" />
                    </svg>
                </span>
                <span class="scraii-ai-filter-row-label pe-2">Selected Filter</span>

                <!-- Brand Filter Dropdown (multiselect + search + "All brands") -->
                <div class="scraii-ai-brand-dropdown-wrapper">
                    <button class="scraii-ai-brand-dropdown-btn" [class.open]="showBrandDropdown"
                        (click)="toggleBrandDropdown($event)"
                        [attr.aria-expanded]="showBrandDropdown"
                        aria-haspopup="listbox"
                        aria-label="Select brand filters">
                    <span class="scraii-ai-brand-btn-label">
                        <!-- {{selectedBrandsLabel}} -->
                       Brand <span class="scraii-ai-brand-btn-label-selected">{{ selectedBrands.length + '/' + (filterOptions.length || 1) }}</span>
                    </span>
                    <!-- Tick shows only when every brand is selected. -->
                    <!-- <mat-icon *ngIf="isAllBrandsSelected" class="scraii-ai-filter-row-check"
                        aria-hidden="true">check_circle</mat-icon> -->
                    <mat-icon class="scraii-ai-brand-btn-arrow" aria-hidden="true">
                        <!-- {{ showBrandDropdown ? 'expand_less' : 'expand_more' }} -->
                        {{ showBrandDropdown ? 'arrow_drop_up' : 'arrow_drop_down'}}
                    </mat-icon>
                </button>

                <div class="scraii-ai-brand-dropdown-panel" *ngIf="showBrandDropdown"
                    (click)="$event.stopPropagation()"
                    role="listbox" aria-multiselectable="true">

                    <!-- Search input — filters the list below by brand_name. -->
                    <div class="scraii-ai-brand-search-wrap">
                        <input type="text"
                            class="scraii-ai-brand-search-input"
                            [(ngModel)]="brandSearchQuery"
                            placeholder="Search brands..."
                            aria-label="Search brands" />
                    </div>

                    <div class="scraii-ai-brand-list">
                        <!-- "All brands" row: toggles select-all / clear-all. Hidden when -->
                        <!-- the user is actively searching, since "All" is ambiguous then. -->
                        <!-- <div class="scraii-ai-brand-item scraii-ai-brand-item--all"
                            *ngIf="!brandSearchQuery"
                            [class.selected]="isAllBrandsSelected"
                            (click)="toggleAllBrands($event)"
                            role="option"
                            [attr.aria-selected]="isAllBrandsSelected">
                            <div class="scraii-ai-brand-checkbox" [class.checked]="isAllBrandsSelected">
                                <mat-icon *ngIf="isAllBrandsSelected"
                                    class="scraii-ai-brand-check-icon" aria-hidden="true">check</mat-icon>
                            </div>
                            <span class="scraii-ai-brand-item-name">All brands</span>
                        </div> -->

                        <!-- Individual brand options. filteredBrands narrows by the search query. -->
                        <div *ngFor="let brand of filteredBrands" class="scraii-ai-brand-item"
                            [class.selected]="isBrandSelected(brand)"
                            (click)="toggleBrandSelection(brand, $event)"
                            role="option"
                            [attr.aria-selected]="isBrandSelected(brand)">
                            <div class="scraii-ai-brand-checkbox" [class.checked]="isBrandSelected(brand)">
                                <mat-icon *ngIf="isBrandSelected(brand)"
                                    class="scraii-ai-brand-check-icon" aria-hidden="true">check</mat-icon>
                            </div>
                            <span class="scraii-ai-brand-item-name">
                                {{ brand.brand_name }}
                            </span>
                        </div>

                        <!-- No-matches state for a non-empty search. -->
                        <div *ngIf="brandSearchQuery && filteredBrands.length === 0"
                            class="scraii-ai-brand-empty">
                            No matches
                        </div>
                    </div>
                </div>
                </div>
            </span>

            <button class="scraii-ai-new-chat-btn-onrow" type="button" (click)="startNewChat(); $event.stopPropagation()">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4V20M20 12H4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                New Chat
            </button>
        </div>

        <div class="scraii-ai-chat-container" #chatContainer
            [ngClass]="{'scraii-ai-centered': messages?.length == 0 || isLoadingMessages}">

            <!-- Loading indicator for chat messages - shows in centered layout -->
            <ng-container *ngIf="isLoadingMessages">
                <div class="scraii-ai-messages-loading">
                    <div class="scraii-ai-typing-indicator">
                        <span></span><span></span><span></span>
                    </div>
                    <p class="scraii-ai-loading-text">Loading conversation...</p>
                </div>
            </ng-container>

            <!-- Empty state - shows when no messages and not loading -->
            <ng-container *ngIf="messages?.length == 0 && !isLoadingMessages">

                <!-- Welcome hero — horizontal row: logo left, text right -->
                <div class="scraii-ai-welcome-hero" *ngIf="!isFloatingView">

                    <!-- Small Neo logo avatar -->
                    <div class="scraii-ai-welcome-logo" aria-hidden="true">
                        <svg viewBox="0 0 120 120" width="44" height="44">
                            <defs>
                                <linearGradient id="wh-edge" x1="0" y1="0" x2="1" y2="1">
                                    <stop offset="0" stop-color="#6B5FA8" />
                                    <stop offset="1" stop-color="#E8A0D8" />
                                </linearGradient>
                                <radialGradient id="wh-nd" cx="50%" cy="50%">
                                    <stop offset="0" stop-color="#6B5FA8" />
                                    <stop offset="1" stop-color="#0C1E52" />
                                </radialGradient>
                                <radialGradient id="wh-nm" cx="50%" cy="50%">
                                    <stop offset="0" stop-color="#E8A0D8" />
                                    <stop offset="1" stop-color="#A03090" />
                                </radialGradient>
                                <radialGradient id="wh-np" cx="50%" cy="50%">
                                    <stop offset="0" stop-color="#50e070" />
                                    <stop offset="1" stop-color="#22c55e" />
                                </radialGradient>
                                <filter id="wh-glow" x="-50%" y="-50%" width="200%" height="200%">
                                    <feGaussianBlur stdDeviation="3" />
                                </filter>
                            </defs>
                            <!-- Edges -->
                            <line x1="28" y1="28" x2="28" y2="92" stroke="url(#wh-edge)" stroke-width="3" opacity="0.55" />
                            <line x1="28" y1="28" x2="92" y2="92" stroke="url(#wh-edge)" stroke-width="3" opacity="0.55" />
                            <line x1="92" y1="28" x2="92" y2="92" stroke="url(#wh-edge)" stroke-width="3" opacity="0.55" />
                            <!-- Animated travel dots -->
                            <circle r="4" fill="#E8E2FF" filter="url(#wh-glow)">
                                <animate attributeName="cx" values="28;28" dur="3.6s" repeatCount="indefinite" />
                                <animate attributeName="cy" values="28;92;92" keyTimes="0;0.33;1" dur="3.6s" repeatCount="indefinite" />
                                <animate attributeName="opacity" values="0;1;1;0;0" keyTimes="0;0.05;0.3;0.35;1" dur="3.6s" repeatCount="indefinite" />
                            </circle>
                            <circle r="4" fill="#FFD4F0" filter="url(#wh-glow)">
                                <animate attributeName="cx" values="28;28;92;92" keyTimes="0;0.33;0.66;1" dur="3.6s" repeatCount="indefinite" />
                                <animate attributeName="cy" values="28;28;92;92" keyTimes="0;0.33;0.66;1" dur="3.6s" repeatCount="indefinite" />
                                <animate attributeName="opacity" values="0;0;1;1;0;0" keyTimes="0;0.33;0.38;0.63;0.68;1" dur="3.6s" repeatCount="indefinite" />
                            </circle>
                            <circle r="4" fill="#22c55e" filter="url(#wh-glow)">
                                <animate attributeName="cx" values="92;92" dur="3.6s" repeatCount="indefinite" />
                                <animate attributeName="cy" values="28;28;92;92" keyTimes="0;0.66;1;1" dur="3.6s" repeatCount="indefinite" />
                                <animate attributeName="opacity" values="0;0;1;1;0" keyTimes="0;0.66;0.71;0.95;1" dur="3.6s" repeatCount="indefinite" />
                            </circle>
                            <!-- Static nodes -->
                            <circle cx="28" cy="28" r="12" fill="url(#wh-nd)">
                                <animate attributeName="r" values="12;15;12" keyTimes="0;0.05;0.2" dur="3.6s" repeatCount="indefinite" />
                            </circle>
                            <circle cx="28" cy="92" r="11" fill="url(#wh-np)">
                                <animate attributeName="r" values="11;11;15;11;11" keyTimes="0;0.3;0.35;0.5;1" dur="3.6s" repeatCount="indefinite" />
                            </circle>
                            <circle cx="92" cy="28" r="11" fill="url(#wh-nm)">
                                <animate attributeName="r" values="11;11;15;11;11" keyTimes="0;0.63;0.68;0.83;1" dur="3.6s" repeatCount="indefinite" />
                            </circle>
                            <circle cx="92" cy="92" r="11" fill="url(#wh-nm)">
                                <animate attributeName="r" values="11;11;15;11" keyTimes="0;0.96;1;1" dur="3.6s" repeatCount="indefinite" />
                            </circle>
                        </svg>
                    </div>

                    <!-- Hero text: headline + description -->
                    <div class="scraii-ai-hero-text">
                        <h1 class="scraii-ai-welcome-headline">
                            Hi{{ userName ? ' ' + (userName | titlecase) : '' }} &mdash;
                            <span class="scraii-ai-neo-highlight">I'm Neo.</span>
                            What are we digging into today?
                        </h1>
                        <p class="scraii-ai-welcome-desc">
                            Ask anything about your specialty pharmacy data &mdash; patient journey, fill rates,
                            HCP activity, data partner health. I'll pull it up and show my work.
                        </p>
                    </div>

                </div>

                <!-- Floating welcome card — suggested questions on initial blank state -->
                <div class="scraii-ai-floating-welcome-stack" *ngIf="showFloatingWelcomeCard">
                    <div class="scraii-ai-floating-welcome-card">
                        <div class="scraii-ai-floating-welcome-header">
                            <span class="scraii-ai-floating-welcome-title">What do you want to ask?</span>
                        </div>
                        <div class="scraii-ai-floating-welcome-scroll">
                            <div *ngFor="let category of suggestedQueryCategories; let last = last"
                                class="scraii-ai-floating-category"
                                [class.is-expanded]="isFloatingCategoryExpanded(category.id)"
                                [class.is-last]="last">
                                <button type="button" class="scraii-ai-floating-category-header"
                                    (click)="toggleFloatingCategory(category.id)"
                                    [attr.aria-expanded]="isFloatingCategoryExpanded(category.id)"
                                    [attr.aria-label]="'Toggle ' + category.label + ' questions'">
                                    <span class="scraii-ai-floating-category-label">
                                        <span class="scraii-ai-suggestion-badge" [ngClass]="category.badgeClass">
                                            {{ category.label }}
                                        </span>
                                        <span class="scraii-ai-floating-category-count">
                                            {{ category.queries.length }}
                                        </span>
                                    </span>
                                    <span class="scraii-ai-floating-category-chevron" aria-hidden="true">
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                            <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </span>
                                </button>
                                <ul class="scraii-ai-floating-welcome-list"
                                    *ngIf="isFloatingCategoryExpanded(category.id)">
                                    <li *ngFor="let q of category.queries">
                                        <button type="button" (click)="selectSampleQuery(q, category.id)">
                                            {{ q }}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Centered input: textarea wrapper with inline Deep Analysis toggle -->
                <div class="scraii-ai-input-wrap scraii-ai-width-50"
                    [class.scraii-ai-input-wrap-floating]="isFloatingView">
                    <textarea #centeredTextarea [(ngModel)]="userInput" rows="1"
                        class="scraii-ai-chat-textarea"
                        [class.scraii-ai-chat-textarea-floating]="isFloatingView"
                        placeholder="Ask Neo anything about your data."
                        (keydown.enter)="handleEnterKey($event)"
                        (input)="adjustTextareaHeight($event)"
                        (ngModelChange)="syncActiveTextareaHeight()"
                        [disabled]="isLoading || isGeneratingChart || isExecutingQuery || isAutoExecuting"></textarea>

                    <!-- Bottom toolbar: Deep Analysis toggle + send/stop -->
                    <div class="scraii-ai-input-toolbar">
                        <!-- Deep Analysis toggle pill -->
                        <label class="scraii-ai-deep-toggle mb-0"
                            [class.active]="summaryInsightEnabled"
                            [class.scraii-ai-deep-toggle-disabled]="isAnyOperationRunning"
                            [matTooltip]="isAnyOperationRunning ? 'Unavailable while a request is in progress' : 'Generate an AI summary with each response'"
                            [matTooltipPosition]="'above'">
                            <input type="checkbox" [checked]="summaryInsightEnabled"
                                [disabled]="isAnyOperationRunning"
                                (change)="toggleSummaryInsight()" />
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span>Insights Summary</span>
                        </label>

                        <div class="scraii-ai-input-actions">
                            <button *ngIf="speechSupported" class="scraii-ai-voice-btn"
                                [class.recording]="isRecording$ | async" [disabled]="isAnyOperationRunning"
                                (click)="toggleVoiceInput()"
                                [matTooltip]="(isRecording$ | async) ? 'Stop voice input' : 'Start voice input'"
                                [matTooltipPosition]="'above'">
                                <svg *ngIf="!(isRecording$ | async)" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <svg *ngIf="isRecording$ | async" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="6" y="6" width="12" height="12" rx="2"/>
                                </svg>
                            </button>
                            <button *ngIf="!isAnyOperationRunning && userInput.trim()" (click)="sendChatbotMessage()"
                                [disabled]="isLoading || !userInput.trim() || isGeneratingChart || isExecutingQuery || isAutoExecuting"
                                class="scraii-ai-send-btn" [class.scraii-ai-send-btn-pulse]="sendBtnPulse">
                                <!-- ➤ -->
                                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 15V1.5M1 7.5L7 1L13 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                            <button *ngIf="isAnyOperationRunning" (click)="stopCurrentOperation()" class="scraii-ai-stop-btn"
                                matTooltip="Stop current operation" [matTooltipPosition]="'above'">
                                <!-- ⏹ -->
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 0H2C0.89543 0 0 0.89543 0 2V12C0 13.1046 0.89543 14 2 14H12C13.1046 14 14 13.1046 14 12V2C14 0.89543 13.1046 0 12 0Z" fill="white"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <!-- Suggestion cards: full query lists with show-more toggle -->
                <div class="scraii-ai-suggestions-grid" *ngIf="!isFloatingView">

                    <!-- Label row with toggle link at the right end -->
                    <div class="scraii-ai-suggestions-label">
                        <span class="scraii-ai-suggestions-label-left">
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            Suggested queries
                            <span class="scraii-ai-suggestions-count">
                                {{ totalSuggestedQueryCount }} total
                            </span>
                        </span>
                        <button class="scraii-ai-suggestions-toggle" (click)="showAllSuggestions = !showAllSuggestions">
                            <ng-container *ngIf="!showAllSuggestions">
                                See all
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                    <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </ng-container>
                            <ng-container *ngIf="showAllSuggestions">
                                Show less
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                    <path d="M18 15l-6-6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </ng-container>
                        </button>
                    </div>

                    <!-- Suggestion cards — first 2 per category when collapsed -->
                    <ng-container *ngFor="let category of suggestedQueryCategories">
                        <ng-container *ngFor="let q of category.queries; let idx = index">
                            <button class="scraii-ai-suggestion-card"
                                *ngIf="showAllSuggestions || idx < 2"
                                (click)="selectSampleQuery(q, category.id)">
                                <span class="scraii-ai-suggestion-badge" [ngClass]="category.badgeClass">
                                    {{ category.label }}
                                </span>
                                <span class="scraii-ai-suggestion-text">{{ q }}</span>
                                <span class="scraii-ai-suggestion-arrow">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                        <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </button>
                        </ng-container>
                    </ng-container>

                </div>

            </ng-container>

            <div *ngFor="let msg of messages; let i = index" [ngClass]="'scraii-ai-' + msg.role">
                <div class="scraii-ai-message w-100">
                    <!-- Assistant avatar: clean circle icon -->
                    <div class="scraii-ai-avatar scraii-ai-avatar-assistant" *ngIf="msg.role === 'assistant'">
                        <svg viewBox="0 0 120 120" width="22" height="22" aria-hidden="true">
                            <defs>
                                <linearGradient id="e-s1" x1="0" y1="0" x2="1" y2="1">
                                    <stop offset="0" stop-color="#6B5FA8" />
                                    <stop offset="1" stop-color="#E8A0D8" />
                                </linearGradient>
                                <radialGradient id="nd-s1" cx="50%" cy="50%">
                                    <stop offset="0" stop-color="#6B5FA8" />
                                    <stop offset="1" stop-color="#0C1E52" />
                                </radialGradient>
                                <radialGradient id="nm-s1" cx="50%" cy="50%">
                                    <stop offset="0" stop-color="#E8A0D8" />
                                    <stop offset="1" stop-color="#A03090" />
                                </radialGradient>
                                <radialGradient id="np-s1" cx="50%" cy="50%">
                                    <stop offset="0" stop-color="#C9BEE4" />
                                    <stop offset="1" stop-color="#4D2D8A" />
                                </radialGradient>
                                <filter id="glow-s1" x="-50%" y="-50%" width="200%" height="200%">
                                    <feGaussianBlur stdDeviation="2.5" />
                                </filter>
                            </defs>
                            <line x1="28" y1="28" x2="28" y2="92" stroke="url(#e-s1)" stroke-width="3" opacity="0.55" />
                            <line x1="28" y1="28" x2="92" y2="92" stroke="url(#e-s1)" stroke-width="3" opacity="0.55" />
                            <line x1="92" y1="28" x2="92" y2="92" stroke="url(#e-s1)" stroke-width="3" opacity="0.55" />
                            <circle r="3.5" fill="#E8E2FF" filter="url(#glow-s1)">
                                <animate attributeName="cx" values="28;28" dur="3.6s" repeatCount="indefinite" />
                                <animate attributeName="cy" values="28;92;92" keyTimes="0;0.33;1" dur="3.6s"
                                    repeatCount="indefinite" />
                                <animate attributeName="opacity" values="0;1;1;0;0" keyTimes="0;0.05;0.3;0.35;1"
                                    dur="3.6s" repeatCount="indefinite" />
                            </circle>
                            <circle r="3.5" fill="#FFD4F0" filter="url(#glow-s1)">
                                <animate attributeName="cx" values="28;28;92;92" keyTimes="0;0.33;0.66;1" dur="3.6s"
                                    repeatCount="indefinite" />
                                <animate attributeName="cy" values="28;28;92;92" keyTimes="0;0.33;0.66;1" dur="3.6s"
                                    repeatCount="indefinite" />
                                <animate attributeName="opacity" values="0;0;1;1;0;0" keyTimes="0;0.33;0.38;0.63;0.68;1"
                                    dur="3.6s" repeatCount="indefinite" />
                            </circle>
                            <circle r="3.5" fill="#A03090" filter="url(#glow-s1)">
                                <animate attributeName="cx" values="92;92" dur="3.6s" repeatCount="indefinite" />
                                <animate attributeName="cy" values="28;28;92;92" keyTimes="0;0.66;1;1" dur="3.6s"
                                    repeatCount="indefinite" />
                                <animate attributeName="opacity" values="0;0;1;1;0" keyTimes="0;0.66;0.71;0.95;1"
                                    dur="3.6s" repeatCount="indefinite" />
                            </circle>
                            <circle cx="28" cy="28" r="11" fill="url(#nd-s1)">
                                <animate attributeName="r" values="11;14;11" keyTimes="0;0.05;0.2" dur="3.6s"
                                    repeatCount="indefinite" />
                            </circle>
                            <circle cx="28" cy="92" r="11" fill="url(#np-s1)">
                                <animate attributeName="r" values="11;11;15;11;11" keyTimes="0;0.3;0.35;0.5;1"
                                    dur="3.6s" repeatCount="indefinite" />
                            </circle>
                            <circle cx="92" cy="28" r="11" fill="url(#nm-s1)">
                                <animate attributeName="r" values="11;11;15;11;11" keyTimes="0;0.63;0.68;0.83;1"
                                    dur="3.6s" repeatCount="indefinite" />
                            </circle>
                            <circle cx="92" cy="92" r="11" fill="url(#nm-s1)">
                                <animate attributeName="r" values="11;11;15;11" keyTimes="0;0.96;1;1" dur="3.6s"
                                    repeatCount="indefinite" />
                            </circle>
                        </svg>
                    </div>

                    <div class="scraii-ai-avatar scraii-ai-avatar-user" *ngIf="msg.role === 'user'">
                        {{ (userName | slice:0:1) || 'U' }}
                    </div>

                    <div class="scraii-ai-message-content-wrapper">

                        <!-- Neo sender name — appears above all content, only for assistant -->
                        <div class="scraii-ai-sender-line" *ngIf="msg.role === 'assistant'">
                            <span class="scraii-ai-sender-name">Neo</span>
                            <span class="scraii-ai-sender-dot">·</span>
                            <span class="scraii-ai-sender-sub">your data analyst</span>
                        </div>

                        <div class="scraii-ai-content"
                            *ngIf="msg.role === 'user' || (msg.role === 'assistant' && !msg.hideSql && (!msg.isHistorical || msg.needs_clarification))">
                            {{ msg.content }}
                        </div>

                        <div class="scraii-ai-result-card"
                            *ngIf="msg.role === 'assistant' && isAnswerOnlyProject(msg.project) && msg.content">
                            <!-- contract_rag: answer split into text + inline table segments -->
                            <ng-container *ngIf="msg.project === 'contract_rag' && msg.contractRagSegments?.length; else defaultAnswerBlock">
                                <ng-container *ngFor="let seg of msg.contractRagSegments">
                                    <!-- Text segment: rendered as markdown -->
                                    <div *ngIf="seg.type === 'text'"
                                        class="scraii-ai-contract-text-segment"
                                        [innerHTML]="$any(seg).content | markdownRender:false">
                                    </div>
                                    <!-- Table segment: structured ag-grid table -->
                                    <div *ngIf="seg.type === 'table' && msg.contractRagRowData && msg.contractRagAgColumns"
                                        class="scraii-ai-contract-table-block">
                                        <ng-container *ngTemplateOutlet="ragAgGrid; context: {
                                            rowData: msg.contractRagRowData[$any(seg).tableIndex] ?? emptyRagGridRows,
                                            columnDefs: msg.contractRagAgColumns[$any(seg).tableIndex] ?? emptyRagGridColumns,
                                            gridKey: getRagGridKey(i, 'table', $any(seg).tableIndex)
                                        }"></ng-container>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <!-- config_ai / enrollment_rag / data_dictionary / contract_rag fallback (no parsed segments) -->
                            <ng-template #defaultAnswerBlock>
                                <div class="scraii-ai-config-answer"
                                    [innerHTML]="msg.content | markdownRender:(isTyping && typingMessageIndex === i)">
                                </div>
                            </ng-template>
                            <!-- RAG structured citations — dynamic columns derived from the data -->
                            <div class="scraii-ai-rag-citations" *ngIf="msg.ragCitations?.length">
                                <div class="scraii-ai-rag-table-panel"
                                    [class.is-expanded]="isRagCitationsExpanded(msg)">
                                    <button type="button" class="scraii-ai-rag-table-toggle"
                                        (click)="toggleRagCitations(msg, i)"
                                        [attr.aria-expanded]="isRagCitationsExpanded(msg)"
                                        [attr.aria-label]="'Toggle ' + getRagCitationsTitle(msg.project)">
                                        <span class="scraii-ai-rag-table-toggle-label">
                                            {{ getRagCitationsTitle(msg.project) }}
                                            <span class="scraii-ai-rag-table-toggle-count">{{ msg.ragCitations.length }}</span>
                                        </span>
                                        <span class="scraii-ai-rag-table-toggle-chevron" aria-hidden="true">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                    </button>
                                    <div class="scraii-ai-rag-table-body"
                                        *ngIf="isRagCitationsExpanded(msg) && (!isTyping || typingMessageIndex !== i)">
                                        <ng-container *ngTemplateOutlet="ragAgGrid; context: {
                                            rowData: msg.ragCitations ?? emptyRagGridRows,
                                            columnDefs: msg.ragCitationAgColumns ?? emptyRagGridColumns,
                                            gridKey: getRagGridKey(i, 'citations')
                                        }"></ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="scraii-ai-result-card-footer"
                                *ngIf="!msg.isHistorical && !msg.apiError && !msg.needs_clarification">
                                <button class="scraii-ai-icon-btn" style="background: #fff;"
                                    matTooltip="Good response" [matTooltipPosition]="'below'"
                                    [disabled]="isTyping && typingMessageIndex === i"
                                    [class.scraii-ai-active]="msg.feedback === 'up'"
                                    (click)="giveFeedback(i, 'up')">
                                    <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle;">thumb_up</mat-icon>
                                </button>
                                <button class="scraii-ai-icon-btn" style="background: #fff;"
                                    matTooltip="Bad response" [matTooltipPosition]="'below'"
                                    [disabled]="isTyping && typingMessageIndex === i"
                                    [class.scraii-ai-active]="msg.feedback === 'down'"
                                    (click)="giveFeedback(i, 'down')">
                                    <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle;">thumb_down</mat-icon>
                                </button>
                                <div class="scraii-ai-summary-meta"
                                    *ngIf="(msg.llmTime !== undefined || msg.dbTime !== undefined) && !msg.apiError">
                                    <span class="scraii-ai-summary-meta-item" *ngIf="msg.llmTime !== undefined">
                                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <circle cx="12" cy="12" r="10" />
                                            <polyline points="12 6 12 12 16 14" />
                                        </svg>
                                        AI: {{ formatTime(msg.llmTime) }}
                                    </span>
                                    <span class="scraii-ai-summary-meta-divider"
                                        *ngIf="msg.llmTime !== undefined && msg.dbTime !== undefined">·</span>
                                    <span class="scraii-ai-summary-meta-item" *ngIf="msg.dbTime !== undefined">
                                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <ellipse cx="12" cy="5" rx="9" ry="3" />
                                            <path d="M3 5v14a9 3 0 0 0 18 0V5" />
                                            <path d="M3 12a9 3 0 0 0 18 0" />
                                        </svg>
                                        DB: {{ formatTime(msg.dbTime) }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Unified result card — wraps historical re-run card AND non-historical error/summary/chart/table/SQL/footer -->
                        <div class="scraii-ai-result-card"
                            *ngIf="msg.role === 'assistant' && (msg.chartConfig || msg.tableData || msg.isLoadingTable || msg.tableError || msg.chartError || msg.apiError || msg.summary || msg.isUnsupportedChart || msg.isHistorical || msg.chartEmpty || msg.tableEmpty || msg.citationSources?.length)">

                            <!-- Historical assistant message — re-run card now lives inside the result card frame -->
                            <div *ngIf="msg.isHistorical && msg.role === 'assistant'" class="scraii-ai-rerun-card">
                                <div class="scraii-ai-rerun-content">
                                    <!-- <mat-icon class="scraii-ai-rerun-icon">replay</mat-icon> -->
                                    <h3>This data may be outdated</h3>
                                    <p>These results are from a previous session and may no longer reflect the latest
                                        information. Refresh to get the most up-to-date data.</p>
                                </div>
                                <button class="scraii-ai-regenerate-btn" (click)="reRunPrompt(i)"
                                    [disabled]="isLoading || isTyping || isGeneratingChart || isExecutingQuery || isAutoExecuting">
                                    <mat-icon>replay</mat-icon>
                                    Refresh Results
                                </button>
                            </div>

                            <!-- Non-historical content branch -->
                            <ng-container *ngIf="!msg.isHistorical">

                                <!-- Citation sources — normal flow; shown whenever API provides sources -->
                                <div *ngIf="msg.citationSources?.length" class="scraii-ai-citation-sources">
                                    <div class="scraii-ai-citation-source">
                                        <span class="scraii-ai-citation-label">Source : </span>
                                        <span class="scraii-ai-citation-value"
                                            [innerHTML]="msg.citationSources!.join(', ') | markdownRender:false"></span>
                                    </div>
                                </div>

                                <!-- AI Summary (chart) — moved to TOP of card -->
                                <div *ngIf="msg.chartConfig && msg.summary && !msg.summaryHidden && (msg.displayedSummary || !msg.isSummaryTyping)"
                                    class="scraii-ai-summary-container">
                                    <div class="scraii-ai-summary-icon">
                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M12 2C8.13 2 5 5.13 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.87-3.13-7-7-7zM9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1z"
                                                fill="#1363df"></path>
                                        </svg>
                                    </div>
                                    <div class="scraii-ai-summary-text"
                                        [innerHTML]="(msg.isSummaryTyping ? msg.displayedSummary : msg.summary) | markdownRender:msg.isSummaryTyping">
                                    </div>
                                </div>

                                <!-- AI Summary (table) — moved to TOP of card -->
                                <div *ngIf="!msg.chartConfig && msg.summary && !msg.summaryHidden && (msg.displayedSummary || !msg.isSummaryTyping)"
                                    class="scraii-ai-summary-container">
                                    <div class="scraii-ai-summary-icon">
                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                                            <path
                                                d="M12 2C8.13 2 5 5.13 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.87-3.13-7-7-7zM9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1z"
                                                fill="#1363df"></path>
                                        </svg>
                                    </div>
                                    <div class="scraii-ai-summary-text"
                                        [innerHTML]="(msg.isSummaryTyping ? msg.displayedSummary : msg.summary) | markdownRender:msg.isSummaryTyping">
                                    </div>
                                </div>

                                <!-- Chart / Table view toggle — only for chart responses that have cached rows. -->
                                <!-- Hidden while the chart is still building, and hidden on legacy-fallback -->
                                <!-- chart messages that have no resultData. We intentionally do NOT gate on -->
                                <!-- msg.isSummaryTyping: chart responses set content synchronously (no content -->
                                <!-- typing animation), and summary typing can run for many seconds even when -->
                                <!-- the summary is hidden — gating on it would suppress the bar invisibly. -->
                                <div class="scraii-ai-view-bar"
                                    *ngIf="msg.chartConfig && msg.activeView && msg.resultData && msg.resultData.length > 0
                                        && !msg.isGenerating
                                        && !msg.chartError && !msg.isUnsupportedChart && !msg.apiError">
                                    <button type="button" class="scraii-ai-view-tab"
                                        [class.active]="msg.activeView === 'chart'"
                                        (click)="switchResultView(i, 'chart')"
                                        [attr.aria-pressed]="msg.activeView === 'chart'"
                                        aria-label="Show chart view">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" aria-hidden="true">
                                            <path d="M3 3v18h18" />
                                            <path d="M7 15l4-6 4 3 5-8" />
                                        </svg>
                                        Chart
                                    </button>
                                    <button type="button" class="scraii-ai-view-tab"
                                        [class.active]="msg.activeView === 'table'"
                                        (click)="switchResultView(i, 'table')"
                                        [attr.aria-pressed]="msg.activeView === 'table'"
                                        aria-label="Show table view">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" aria-hidden="true">
                                            <rect x="3" y="4" width="18" height="16" rx="2" />
                                            <path d="M3 10h18M3 15h18M9 4v16M15 4v16" />
                                        </svg>
                                        Table
                                    </button>
                                    <!-- <span class="scraii-ai-view-meta">
                                        {{ msg.resultData.length }} {{ msg.resultData.length === 1 ? 'row' : 'rows' }}
                                    </span> -->
                                </div>

                                <!-- API error card: backend-reported error (res.error). Reuses .scraii-ai-chart-error-card. -->
                                <div *ngIf="msg.apiError" class="scraii-ai-chart-error-card">
                                    <div class="scraii-ai-error-content">
                                        <mat-icon class="scraii-ai-error-icon">error_outline</mat-icon>
                                        <p>{{ msg.apiError }}</p>
                                    </div>
                                </div>

                                <!-- Empty-result info card — 200 response with result: [] for a -->
                                <!-- chart OR table request. Hidden when a summary is visible, since -->
                                <!-- the summary already explains the empty response. -->
                                <div *ngIf="(msg.chartEmpty || msg.tableEmpty) && (!msg.summary || msg.summaryHidden)"
                                    class="scraii-ai-info-card">
                                    <div class="scraii-ai-info-content">
                                        <mat-icon class="scraii-ai-info-icon" aria-hidden="true">search_off</mat-icon>
                                        <p class="scraii-ai-info-title">No data for this query</p>
                                        <p class="scraii-ai-info-subtitle">
                                            Your query ran successfully but didn't return any rows.
                                            Try adjusting the filters or rephrasing the question.
                                        </p>
                                    </div>
                                </div>

                                <!-- Inline Query Results -->
                                <div *ngIf="showQueryResults && activeResultIndex === i"
                                    class="scraii-ai-inline-results" [class.scraii-ai-fullscreen]="!isFloatingView && isResultFullScreen">
                                    <div class="scraii-ai-results-header-inline">
                                        <h3>Query Results</h3>
                                        <span class="d-flex" *ngIf="!isFloatingView">
                                            <button class="scraii-ai-close-btn-inline" style="margin-right: 8px;"
                                                (click)="toggleResultFullScreen()">
                                                <mat-icon
                                                    [matTooltip]=" isResultFullScreen  ? ' Exit Full Screen': 'Show Full Screen'"
                                                    class="matIcons"
                                                    [svgIcon]="isResultFullScreen ? 'collapse_arrow':'expand_circle'">
                                                </mat-icon>
                                            </button>
                                            <!-- <button class="scraii-ai-close-btn-inline" *ngIf="!isResultFullScreen"
                                                matTooltip="Close" (click)="closeQueryResults()">&times;</button> -->
                                        </span>
                                    </div>

                                    <div *ngIf="!isExecutingQuery && queryResults.length > 0 && !queryError"
                                        class="scraii-ai-results-info">
                                        <span><strong>{{ queryResults.length }}</strong> row(s) returned</span>
                                        <span><strong>{{ queryResultColumns.length }}</strong> column(s)</span>
                                    </div>

                                    <div class="scraii-ai-table-wrapper-inline">
                                        <!-- Loading indicator inside table wrapper -->
                                        <div *ngIf="isExecutingQuery" class="scraii-ai-table-loading">
                                            <div class="scraii-ai-typing-indicator">
                                                <span></span><span></span><span></span>
                                            </div>
                                            <p>Loading data...</p>
                                        </div>

                                        <!-- Error state inside card -->
                                        <div *ngIf="!isExecutingQuery && queryError" class="scraii-ai-chart-error-card">
                                            <div class="scraii-ai-error-content">
                                                <mat-icon class="scraii-ai-error-icon">error_outline</mat-icon>
                                                <p>{{ queryError }}</p>
                                                <p>We couldn't process your request. Please try rephrasing your
                                                    question.</p>
                                            </div>
                                            <button class="scraii-ai-regenerate-btn" (click)="executeQuery(i)"
                                                [disabled]="isLoading || isGeneratingChart || isExecutingQuery || isAutoExecuting">
                                                <mat-icon>refresh</mat-icon>
                                                Regenerate Query
                                            </button>
                                        </div>

                                        <!-- AG-Grid table - shows when data is loaded -->
                                        <ag-grid-angular
                                            *ngIf="!isExecutingQuery && queryResults.length > 0 && !queryError"
                                            style="width: 100%; height: auto;" class="ag-theme-balham patientGrid"
                                            [rowData]="queryResults" [columnDefs]="columnDefs"
                                            [defaultColDef]="defaultColDef" [pagination]="true"
                                            [paginationPageSize]="!isFloatingView && isResultFullScreen ? undefined : 10"
                                            [paginationAutoPageSize]="!isFloatingView && isResultFullScreen"
                                            (gridReady)="onGridReady($event)">
                                        </ag-grid-angular>
                                    </div>
                                    <div *ngIf="!isExecutingQuery && queryResults.length === 0 && !queryError"
                                        class="scraii-ai-results-empty">
                                        <p>No results found</p>
                                    </div>
                                </div>


                                <!-- Inline Chart Display - Now per message -->
                                <!-- Show the container while the chart is generating, exists, or has error, -->
                                <!-- AND also while we are on chart view with cached rows — this keeps the -->
                                <!-- <canvas> element in the DOM across table→chart toggles so Chart.js can -->
                                <!-- attach without remounting (no shimmer flash, no bar flicker). -->
                                <div *ngIf="msg.chartConfig
                                        && msg.chartConfig.chart_type !== 'control_chart'
                                        && msg.chartConfig.chart_type !== 'gantt_chart'
                                        && (msg.isGenerating || msg.chartInstance || msg.chartError
                                            || (msg.activeView === 'chart' && msg.resultData && msg.resultData.length > 0))
                                        && msg.activeView !== 'table'"
                                    class="scraii-ai-chart-container"
                                    [class.scraii-ai-fullscreen]="!isFloatingView && fullScreenChartIndex === i">
                                    <div class="scraii-ai-chart-header">
                                        <h3>📊 {{ msg.chartConfig.title || 'Chart Visualization' }}</h3>

                                        <span class="d-flex" *ngIf="!isFloatingView">
                                            <button class="scraii-ai-close-btn-inline" style="margin-right: 8px;"
                                                (click)="toggleChartFullScreen(i)">
                                                <mat-icon
                                                    [matTooltip]=" fullScreenChartIndex === i  ? ' Exit Full Screen': 'Show Full Screen'"
                                                    class="matIcons"
                                                    [svgIcon]="fullScreenChartIndex === i ? 'collapse_arrow':'expand_circle'">
                                                </mat-icon>
                                            </button>
                                            <!-- <button *ngIf="fullScreenChartIndex !== i"
                                                class="scraii-ai-close-btn-inline" matTooltip="Close"
                                                (click)="closeChart(i)">&times;</button> -->

                                        </span>
                                    </div>

                                    <!-- Loading animation (Generating Chart card) -->
                                    <div *ngIf="msg.isGenerating" class="scraii-ai-chart-loading">
                                        <div class="scraii-ai-shimmer-card">
                                            <div class="scraii-ai-shimmer-text">Generating chart...</div>
                                        </div>
                                    </div>

                                    <!-- Error state inside card -->
                                    <div *ngIf="!msg.isGenerating && msg.chartError" class="scraii-ai-chart-error-card">
                                        <div class="scraii-ai-error-content">
                                            <mat-icon class="scraii-ai-error-icon">error_outline</mat-icon>
                                            <p>{{ msg.chartError }}</p>
                                            <p>We couldn't process your request. Please try rephrasing your question.
                                            </p>
                                        </div>
                                        <button class="scraii-ai-regenerate-btn" (click)="generateChart(i)"
                                            [disabled]="isLoading || isGeneratingChart || isExecutingQuery || isAutoExecuting">
                                            <mat-icon>refresh</mat-icon>
                                            Regenerate Chart
                                        </button>
                                    </div>
                                    <!-- Chart canvas - Hidden during generation, visible after. -->
                                    <!-- Also kept mounted during chart-view with cached rows so the canvas -->
                                    <!-- survives a table↔chart toggle and Chart.js can render immediately. -->
                                    <div *ngIf="!msg.chartError
                                            && (msg.isGenerating || msg.chartInstance
                                                || (msg.activeView === 'chart' && msg.resultData && msg.resultData.length > 0))"
                                        class="scraii-ai-chart-wrapper"
                                        [style.display]="msg.isGenerating && !msg.chartInstance ? 'none' : 'flex'">

                                        <!-- Brush Navigator: vertical strip beside horizontal bar charts -->
                                        <div *ngIf="msg.chartInstance && msg.brushState?.show && msg.brushState?.isHorizontal"
                                            class="scraii-ai-brush-container scraii-ai-brush-vertical">
                                            <canvas [id]="'brushCanvas-' + i" class="scraii-ai-brush-canvas"></canvas>
                                        </div>

                                        <canvas [id]="'chartCanvas-' + i"></canvas>
                                    </div>

                                    <!-- Brush Navigator: horizontal strip below vertical charts -->
                                    <div *ngIf="msg.chartInstance && msg.brushState?.show && !msg.brushState?.isHorizontal"
                                        class="scraii-ai-brush-container scraii-ai-brush-horizontal">
                                        <canvas [id]="'brushCanvas-' + i" class="scraii-ai-brush-canvas"></canvas>
                                    </div>
                                </div>

                                <!-- Control Chart (D3) — rendered by the standalone app-scraii-control-chart -->
                                <!-- component. Reuses the same container shell, header and fullscreen -->
                                <!-- toggle as the Chart.js charts. -->
                                <div *ngIf="msg.chartConfig
                                        && msg.chartConfig.chart_type === 'control_chart'
                                        && msg.activeView !== 'table'
                                        && msg.resultData && msg.resultData.length > 0"
                                    [id]="'controlChart-' + i"
                                    class="scraii-ai-chart-container"
                                    [class.scraii-ai-fullscreen]="!isFloatingView && fullScreenChartIndex === i">
                                    <div class="scraii-ai-chart-header">
                                        <h3>📊 {{ msg.chartConfig.title || 'Control Chart' }}</h3>
                                        <span class="d-flex" *ngIf="!isFloatingView">
                                            <button class="scraii-ai-close-btn-inline" style="margin-right: 8px;"
                                                (click)="toggleChartFullScreen(i)">
                                                <mat-icon
                                                    [matTooltip]="fullScreenChartIndex === i ? ' Exit Full Screen' : 'Show Full Screen'"
                                                    class="matIcons"
                                                    [svgIcon]="fullScreenChartIndex === i ? 'collapse_arrow' : 'expand_circle'">
                                                </mat-icon>
                                            </button>
                                        </span>
                                    </div>
                                    <div class="scraii-ai-chart-wrapper">
                                        <app-scraii-control-chart
                                            [data]="msg.resultData"
                                            [config]="msg.chartConfig"
                                            [isFullscreen]="!isFloatingView && fullScreenChartIndex === i"
                                            [isFloatingView]="isFloatingView"
                                            [isFloatingExpanded]="isFloatingExpanded">
                                        </app-scraii-control-chart>
                                    </div>
                                </div>

                                <!-- Patient Journey Gantt Chart — rendered by app-scraii-gantt-chart -->
                                <div *ngIf="msg.chartConfig
                                        && msg.chartConfig.chart_type === 'gantt_chart'
                                        && msg.chartConfig.patient_journey
                                        && msg.activeView !== 'table'
                                        && (msg.isGenerating || (msg.resultData && msg.resultData.length > 0) || msg.chartError)"
                                    [id]="'ganttChart-' + i"
                                    class="scraii-ai-chart-container scraii-ai-gantt-container"
                                    [class.scraii-ai-fullscreen]="!isFloatingView && fullScreenChartIndex === i">
                                    <div class="scraii-ai-chart-header">
                                        <h3>📊 {{ msg.chartConfig.title || 'Patient Journey' }}</h3>
                                        <span class="d-flex">
                                            <button class="scraii-ai-close-btn-inline" style="margin-right: 8px;"
                                                *ngIf="msg.resultData && msg.resultData.length > 0"
                                                (click)="toggleGanttTreeExpand(i)">
                                                <mat-icon
                                                    [matTooltip]="msg.ganttTreeExpanded ? 'Collapse All' : 'Expand All'"
                                                    class="matIcons"
                                                    [svgIcon]="msg.ganttTreeExpanded ? 'collapse_new' : 'gridload_circle'">
                                                </mat-icon>
                                            </button>
                                            <button class="scraii-ai-close-btn-inline" style="margin-right: 8px;"
                                                *ngIf="!isFloatingView"
                                                (click)="toggleChartFullScreen(i)">
                                                <mat-icon
                                                    [matTooltip]="fullScreenChartIndex === i ? ' Exit Full Screen' : 'Show Full Screen'"
                                                    class="matIcons"
                                                    [svgIcon]="fullScreenChartIndex === i ? 'collapse_arrow' : 'expand_circle'">
                                                </mat-icon>
                                            </button>
                                        </span>
                                    </div>

                                    <div *ngIf="msg.isGenerating && (!msg.resultData || msg.resultData.length === 0)"
                                        class="scraii-ai-chart-loading">
                                        <div class="scraii-ai-shimmer-card">
                                            <div class="scraii-ai-shimmer-text">Loading patient journey...</div>
                                        </div>
                                    </div>

                                    <div *ngIf="msg.chartError" class="scraii-ai-chart-error-card">
                                        <div class="scraii-ai-error-content">
                                            <mat-icon class="scraii-ai-error-icon">error_outline</mat-icon>
                                            <p>{{ msg.chartError }}</p>
                                        </div>
                                        <button class="scraii-ai-regenerate-btn" (click)="generateChart(i)"
                                            [disabled]="isLoading || isGeneratingChart">
                                            <mat-icon>refresh</mat-icon>
                                            Retry
                                        </button>
                                    </div>

                                    <div *ngIf="!msg.chartError && msg.resultData && msg.resultData.length > 0"
                                        class="scraii-ai-chart-wrapper">
                                        <app-scraii-gantt-chart
                                            [chartContainerId]="'scraiiGantt-' + i"
                                            [data]="msg.resultData"
                                            [programData]="msg.programResultData || []"
                                            [config]="msg.chartConfig"
                                            [isFullscreen]="!isFloatingView && fullScreenChartIndex === i"
                                            [isFloatingView]="isFloatingView"
                                            [isFloatingExpanded]="isFloatingExpanded">
                                        </app-scraii-gantt-chart>
                                    </div>
                                </div>

                                <!-- Fallback UI for Unsupported Charts -->
                                <!-- Shows when chart type/variant is not supported -->
                                <div *ngIf="msg.chartConfig && msg.isUnsupportedChart && msg.chartConfig.chart_type !== 'control_chart' && msg.chartConfig.chart_type !== 'gantt_chart'"
                                    class="scraii-ai-chart-container">
                                    <div class="scraii-ai-chart-header">
                                        <h3>📊 {{ msg.chartConfig.title || 'Chart Visualization' }}</h3>
                                        <!-- <button class="scraii-ai-close-btn-inline"
                                            (click)="closeChart(i)">&times;</button> -->
                                    </div>

                                    <div class="scraii-ai-chart-error-card">
                                        <div class="scraii-ai-error-content">
                                            <mat-icon class="scraii-ai-error-icon">error_outline</mat-icon>
                                            <p>This chart type <strong>({{ msg.chartConfig.chart_type | titlecase }} -
                                                    {{
                                                    (msg.chartConfig.chart_variant || 'Simple') | titlecase }})</strong>
                                                is not
                                                currently supported. It will be available soon.</p>
                                        </div>
                                        <!-- No regenerate button for unsupported charts -->
                                    </div>
                                </div>

                                <!-- Per-message Table Results. Two callers now share this block: -->
                                <!--   1. Non-chart SQL responses (existing auto-execute flow) -->
                                <!--   2. Chart responses whose view-tab bar is flipped to 'table' -->
                                <!-- The close (×) button only shows in case 1 — in case 2 the user flips -->
                                <!-- back via the Chart tab, so an extra close action would be redundant. -->
                                <div *ngIf="(msg.isLoadingTable || msg.tableData || msg.tableError)
                                        && (!msg.chartConfig || msg.activeView === 'table')"
                                    class="scraii-ai-inline-results"
                                    [class.scraii-ai-fullscreen]="!isFloatingView && fullScreenTableIndex === i">
                                    <div class="scraii-ai-results-header-inline">
                                        <h3>Query Results</h3>
                                        <span class="d-flex" *ngIf="!isFloatingView">
                                            <button class="scraii-ai-close-btn-inline" style="margin-right: 8px;"
                                                (click)="toggleTableFullScreen(i)">
                                                <mat-icon
                                                    [matTooltip]="fullScreenTableIndex === i ? 'Exit Full Screen' : 'Show Full Screen'"
                                                    class="matIcons"
                                                    [svgIcon]="fullScreenTableIndex === i ? 'collapse_arrow' : 'expand_circle'">
                                                </mat-icon>
                                            </button>
                                            <!-- <button class="scraii-ai-close-btn-inline"
                                                *ngIf="fullScreenTableIndex !== i && !msg.chartConfig"
                                                matTooltip="Close"
                                                (click)="closeMessageTable(i)">&times;</button> -->
                                        </span>
                                    </div>

                                    <div *ngIf="!msg.isLoadingTable && msg.tableData && msg.tableData.length > 0 && !msg.tableError"
                                        class="scraii-ai-results-info">
                                        <span><strong>{{ msg.tableData.length }}</strong> row(s) returned</span>
                                        <span><strong>{{ msg.tableColumns?.length }}</strong> column(s)</span>
                                    </div>

                                    <div class="scraii-ai-table-wrapper-inline"
                                        *ngIf="msg.isLoadingTable || msg.tableError || (msg.tableData && msg.tableData.length > 0)">
                                        <!-- Loading indicator -->
                                        <div *ngIf="msg.isLoadingTable" class="scraii-ai-table-loading">
                                            <div class="scraii-ai-typing-indicator">
                                                <span></span><span></span><span></span>
                                            </div>
                                            <p>Loading data...</p>
                                        </div>

                                        <!-- Error state -->
                                        <div *ngIf="!msg.isLoadingTable && msg.tableError"
                                            class="scraii-ai-chart-error-card">
                                            <div class="scraii-ai-error-content">
                                                <mat-icon class="scraii-ai-error-icon">error_outline</mat-icon>
                                                <p>{{ msg.tableError }}</p>
                                                <p>We couldn't process your request. Please try rephrasing your
                                                    question.</p>
                                            </div>
                                            <button class="scraii-ai-regenerate-btn" (click)="autoExecuteQuery(i)"
                                                [disabled]="isLoading || isGeneratingChart || isExecutingQuery || isAutoExecuting">
                                                <mat-icon>refresh</mat-icon>
                                                Regenerate Query
                                            </button>
                                        </div>

                                        <!-- AG-Grid table -->
                                        <ag-grid-angular
                                            *ngIf="!msg.isLoadingTable && msg.tableData && msg.tableData.length > 0 && !msg.tableError"
                                            style="width: 100%; height: auto;" class="ag-theme-balham patientGrid"
                                            [rowData]="msg.tableData" [columnDefs]="msg.tableColumns || []"
                                            [defaultColDef]="defaultColDef" [pagination]="true"
                                            [paginationPageSize]="!isFloatingView && fullScreenTableIndex === i ? undefined : 10"
                                            [paginationAutoPageSize]="!isFloatingView && fullScreenTableIndex === i"
                                            (gridReady)="onMessageGridReady(i, $event)">
                                        </ag-grid-angular>
                                    </div>

                                    <div *ngIf="!msg.isLoadingTable && msg.tableData && msg.tableData.length === 0 && !msg.tableError"
                                        class="scraii-ai-results-empty">
                                        <p>No results found</p>
                                    </div>
                                </div>

                                <!-- Formatted SQL card - expands/collapses via max-height transition -->
                                <div class="scraii-ai-sql-card" *ngIf="canShowSqlToggle(msg)"
                                    [class.scraii-ai-sql-card-open]="msg.showSql" aria-live="polite">
                                    <div class="scraii-ai-sql-card-header">
                                        <span class="scraii-ai-sql-card-title">SQL</span>
                                        <span class="d-flex gap-1">
                                            <button class="scraii-ai-sql-copy-btn" (click)="copySqlToClipboard(i)"
                                                [matTooltip]="copiedSqlIndex === i ? 'Copied!' : 'Copy SQL'"
                                                [matTooltipPosition]="'above'" aria-label="Copy SQL to clipboard">
                                                <mat-icon *ngIf="copiedSqlIndex !== i"
                                                    style="font-size: 16px; width: 16px; height: 16px;">content_copy</mat-icon>
                                                <mat-icon *ngIf="copiedSqlIndex === i"
                                                    style="font-size: 16px; width: 16px; height: 16px;">check</mat-icon>
                                            </button>
                                            <!-- Hide SQL button -->
                                            <!-- <button class="scraii-ai-sql-copy-btn" (click)="toggleSqlCard(i)"
                                                [matTooltip]="'Hide SQL'" [matTooltipPosition]="'above'"
                                                aria-label="Hide SQL">
                                                <mat-icon style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle;">code</mat-icon>
                                            </button> -->
                                        </span>
                                    </div>
                                    <pre class="scraii-ai-sql-card-body">{{ formatSql(getSqlForMessage(msg)) }}</pre>
                                </div>

                                <!-- Result card footer: feedback + SQL toggle + timing chip -->
                                <div class="scraii-ai-result-card-footer"
                                    *ngIf="msg.role === 'assistant' && !msg.apiError && !msg.needs_clarification && (msg.chartConfig || msg.tableData || msg.isLoadingTable)">
                                    <!-- Added this condition to temperarily hide copy button for auto-execute tables -->
                                    <button *ngIf="!hasChartData(msg) && 1+1 == 4" class="scraii-ai-icon-btn"
                                        (click)="copyMessage(msg.content, i)"
                                        [matTooltip]="copiedIndex === i ? 'Copied!' : 'Copy'"
                                        [matTooltipPosition]="'below'"
                                        [disabled]="isTyping && typingMessageIndex === i">
                                        <span *ngIf="copiedIndex !== i">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#000"
                                                viewBox="0 0 24 24">
                                                <path
                                                    d="M16 1H4C2.9 1 2 1.9 2 3v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                                            </svg>
                                        </span>
                                        <span *ngIf="copiedIndex === i">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#000"
                                                viewBox="0 0 24 24">
                                                <path d="M9 16.2l-4.2-4.2-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                                            </svg>
                                        </span>
                                    </button>
                                    <button *ngIf="!msg.needs_clarification && !msg.apiError" class="scraii-ai-icon-btn" style="background: #fff;"
                                        matTooltip="Good response" [matTooltipPosition]="'below'"
                                        [disabled]="isTyping && typingMessageIndex === i"
                                        [class.scraii-ai-active]="msg.feedback === 'up'"
                                        (click)="giveFeedback(i, 'up')">
                                        <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle;">thumb_up</mat-icon>
                                    </button>
                                    <button *ngIf="!msg.needs_clarification && !msg.apiError" class="scraii-ai-icon-btn" style="background: #fff;"
                                        matTooltip="Bad response" [matTooltipPosition]="'below'"
                                        [disabled]="isTyping && typingMessageIndex === i"
                                        [class.scraii-ai-active]="msg.feedback === 'down'"
                                        (click)="giveFeedback(i, 'down')">
                                        <mat-icon style="font-size: 14px; width: 14px; height: 14px; vertical-align: middle;">thumb_down</mat-icon>
                                    </button>
                                    <!-- Run Query Button - only show if message contains SQL and is not a clarification question and is not a chart response -->
                                    <button class="scraii-ai-icon-btn scraii-ai-run-query-btn"
                                        matTooltip="Query Results" [matTooltipPosition]="'below'"
                                        *ngIf="hasSqlQuery(msg.content) && !msg.needs_clarification && !hasChartData(msg) && 1+2 == 5"
                                        [disabled]="isLoading || (isTyping && typingMessageIndex === i) || isGeneratingChart || isExecutingQuery || isAutoExecuting"
                                        (click)="openQueryDialog(i)">
                                        <mat-icon
                                            style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; color: #0b1636;">play_arrow</mat-icon>
                                    </button>
                                    <!-- Generate Chart Button - only show if message contains chart data -->
                                    <button class="scraii-ai-icon-btn scraii-ai-chart-btn" matTooltip="Generate Chart"
                                        [matTooltipPosition]="'below'" *ngIf="hasChartData(msg) && 1+2 == 5"
                                        [disabled]="isGeneratingChart || isLoading || (isTyping && typingMessageIndex === i) || isExecutingQuery"
                                        (click)="generateChart(i)">
                                        📊
                                    </button>
                                    <!-- Show/Hide SQL toggle - available once the chart or table has rendered -->
                                    <button class="scraii-ai-sql-toggle-btn" *ngIf="canShowSqlToggle(msg)"
                                        [class.scraii-ai-sql-toggle-btn-active]="msg.showSql"
                                        [matTooltip]="msg.showSql ? 'Hide SQL' : 'View SQL'"
                                        [matTooltipPosition]="'below'" (click)="toggleSqlCard(i)"
                                        aria-label="Toggle SQL">
                                        <mat-icon
                                            style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle;">code</mat-icon>
                                        {{msg.showSql ? 'Hide SQL' : 'View SQL'}}
                                    </button>
                                    <div class="scraii-ai-summary-meta"
                                        *ngIf="(msg.llmTime !== undefined || msg.dbTime !== undefined) && !msg.apiError && (msg.chartConfig || msg.tableData)">
                                        <span class="scraii-ai-summary-meta-item" *ngIf="msg.llmTime !== undefined">
                                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <circle cx="12" cy="12" r="10" />
                                                <polyline points="12 6 12 12 16 14" />
                                            </svg>
                                            AI: {{ formatTime(msg.llmTime) }}
                                        </span>
                                        <span class="scraii-ai-summary-meta-divider"
                                            *ngIf="msg.llmTime !== undefined && msg.dbTime !== undefined">·</span>
                                        <span class="scraii-ai-summary-meta-item" *ngIf="msg.dbTime !== undefined">
                                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round">
                                                <ellipse cx="12" cy="5" rx="9" ry="3" />
                                                <path d="M3 5v14a9 3 0 0 0 18 0V5" />
                                                <path d="M3 12a9 3 0 0 0 18 0" />
                                            </svg>
                                            DB: {{ formatTime(msg.dbTime) }}
                                        </span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <!-- ops_overview — inline thinking while polling -->
                        <div class="scraii-ai-ops-thinking"
                            *ngIf="msg.role === 'assistant' && msg.isLoadingOpsOverview">
                            <div class="scraii-ai-ops-thinking-row">
                                <div class="scraii-ai-typing-indicator scraii-ai-ops-thinking-dots">
                                    <span></span><span></span><span></span>
                                </div>
                                <span class="scraii-ai-ops-thinking-label">
                                    {{ processingStatusMessage || 'Working on your request...' }}
                                </span>
                            </div>
                        </div>

                        <!-- ops_overview — monitor status cards grid (revealed progressively) -->
                        <div class="scraii-ai-ops-overview scraii-ai-ops-loaded"
                            *ngIf="msg.role === 'assistant' && msg.opsMonitors?.length && !msg.isLoadingOpsOverview">

                            <!-- Overall summary banner -->
                            <div class="scraii-ai-ops-banner scraii-ai-ops-banner-reveal"
                                *ngIf="shouldShowOpsBanner(msg)">
                                <span class="scraii-ai-ops-banner-dot"
                                    [ngClass]="getMonitorStatusClass(msg.opsOverallStatus || '')"></span>
                                <span class="scraii-ai-ops-banner-text">{{ msg.opsOverallSummary }}</span>
                            </div>

                            <!-- Single-column card list -->
                            <div class="scraii-ai-ops-grid">
                                <div *ngFor="let mon of getVisibleOpsMonitors(msg); let opi = index"
                                    class="scraii-ai-ops-card scraii-ai-ops-card-reveal"
                                    [ngClass]="getMonitorStatusClass(mon.status)">

                                    <!-- Card header row: dot + title left, badge right -->
                                    <div class="scraii-ai-ops-card-header" [ngClass]="getMonitorStatusClass(mon.status)">
                                        <div class="scraii-ai-ops-card-title-group">
                                            <span class="scraii-ai-ops-card-dot"
                                                [ngClass]="getMonitorStatusClass(mon.status)"></span>
                                            <div class="scraii-ai-ops-card-title-wrap">
                                                <span class="scraii-ai-ops-card-title">{{ mon.label }}</span>
                                                <!-- Headline subtitle below title -->
                                                <span class="scraii-ai-ops-headline"
                                                    *ngIf="mon.headline"
                                                    [ngClass]="getMonitorStatusClass(mon.status)">
                                                    {{ mon.headline }}
                                                </span>
                                            </div>
                                        </div>
                                        <span class="scraii-ai-ops-badge"
                                            [ngClass]="getMonitorStatusClass(mon.status)">
                                            <span class="scraii-ai-ops-badge-dot"></span>
                                            {{ mon.status === 'no_data' ? 'No Data' : (mon.status | titlecase) }}
                                        </span>
                                    </div>

                                    <!-- Metrics row — horizontally centered with colored values -->
                                    <div class="scraii-ai-ops-metrics" *ngIf="mon.metrics?.length">
                                        <div *ngFor="let m of mon.metrics" class="scraii-ai-ops-metric-item">
                                            <span class="scraii-ai-ops-metric-value"
                                                [style.color]="getMetricValueColor(m)">{{ m.value ?? 0 }}</span>
                                            <span class="scraii-ai-ops-metric-label">{{ m.label | uppercase }}</span>
                                        </div>
                                    </div>

                                    <!-- Per-monitor summary paragraph -->
                                    <p class="scraii-ai-ops-card-summary" *ngIf="mon.summary">{{ mon.summary }}</p>

                                    <!-- Alerts list -->
                                    <div class="scraii-ai-ops-alerts" *ngIf="mon.alerts?.length">
                                        <div *ngFor="let alert of mon.alerts"
                                            class="scraii-ai-ops-alert-row"
                                            [ngClass]="getMonitorStatusClass(alert.severity)">
                                            <span class="scraii-ai-ops-alert-label">{{ alert.label }}:</span>
                                            <span class="scraii-ai-ops-alert-msg">{{ alert.message }}</span>
                                        </div>
                                    </div>

                                    <!-- Citation sources -->
                                    <!-- <div class="scraii-ai-ops-citation"
                                        *ngIf="mon.citation?.sources?.length">
                                        <span *ngFor="let src of mon.citation!.sources"
                                            [innerHTML]="src | markdownRender:false"></span>
                                    </div> -->
                                </div>
                            </div>

                            <!-- Timing meta row -->
                            <div class="scraii-ai-summary-meta"
                                *ngIf="isOpsRevealComplete(msg) && (msg.llmTime !== undefined || msg.dbTime !== undefined)">
                                <span class="scraii-ai-summary-meta-item" *ngIf="msg.llmTime !== undefined">
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <circle cx="12" cy="12" r="10" />
                                        <polyline points="12 6 12 12 16 14" />
                                    </svg>
                                    AI: {{ formatTime(msg.llmTime) }}
                                </span>
                                <span class="scraii-ai-summary-meta-divider"
                                    *ngIf="msg.llmTime !== undefined && msg.dbTime !== undefined">·</span>
                                <span class="scraii-ai-summary-meta-item" *ngIf="msg.dbTime !== undefined">
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <ellipse cx="12" cy="5" rx="9" ry="3" />
                                        <path d="M3 5v14a9 3 0 0 0 18 0V5" />
                                        <path d="M3 12a9 3 0 0 0 18 0" />
                                    </svg>
                                    DB: {{ formatTime(msg.dbTime) }}
                                </span>
                            </div>
                        </div>

                        <!-- Fallback actions for assistant messages WITHOUT a result card (plain text, clarification) -->
                        <div class="scraii-ai-message-actions"
                            *ngIf="msg.role === 'assistant' && !msg.isHistorical && !isAnswerOnlyProject(msg.project) && !msg.chartConfig && !msg.tableData && !msg.isLoadingTable && !msg.tableError && !msg.apiError && !msg.summary && !msg.isUnsupportedChart && !msg.chartEmpty && !msg.tableEmpty && !msg.isLoadingOpsOverview && !msg.opsMonitors?.length">
                            <button *ngIf="!hasChartData(msg) && 1+1 == 4" class="scraii-ai-icon-btn"
                                (click)="copyMessage(msg.content, i)"
                                [matTooltip]="copiedIndex === i ? 'Copied!' : 'Copy'" [matTooltipPosition]="'below'"
                                [disabled]="isTyping && typingMessageIndex === i">
                                <span *ngIf="copiedIndex !== i">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#000"
                                        viewBox="0 0 24 24">
                                        <path
                                            d="M16 1H4C2.9 1 2 1.9 2 3v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                                    </svg>
                                </span>
                                <span *ngIf="copiedIndex === i">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#000"
                                        viewBox="0 0 24 24">
                                        <path d="M9 16.2l-4.2-4.2-1.4 1.4L9 19 21 7l-1.4-1.4z" />
                                    </svg>
                                </span>
                            </button>
                            <button *ngIf="!msg.needs_clarification && !msg.apiError" class="scraii-ai-icon-btn"
                                matTooltip="Good response" [matTooltipPosition]="'below'"
                                [disabled]="isTyping && typingMessageIndex === i"
                                [class.scraii-ai-active]="msg.feedback === 'up'" (click)="giveFeedback(i, 'up')">
                                👍
                            </button>
                            <button *ngIf="!msg.needs_clarification && !msg.apiError" class="scraii-ai-icon-btn"
                                matTooltip="Bad response" [matTooltipPosition]="'below'"
                                [disabled]="isTyping && typingMessageIndex === i"
                                [class.scraii-ai-active]="msg.feedback === 'down'" (click)="giveFeedback(i, 'down')">
                                👎
                            </button>
                            <button class="scraii-ai-icon-btn scraii-ai-run-query-btn" matTooltip="Query Results"
                                [matTooltipPosition]="'below'"
                                *ngIf="hasSqlQuery(msg.content) && !msg.needs_clarification && !hasChartData(msg) && 1+2 == 5"
                                [disabled]="isLoading || (isTyping && typingMessageIndex === i) || isGeneratingChart || isExecutingQuery || isAutoExecuting"
                                (click)="openQueryDialog(i)">
                                <mat-icon
                                    style="font-size: 18px; width: 18px; height: 18px; vertical-align: middle; color: #0b1636;">play_arrow</mat-icon>
                            </button>
                            <button class="scraii-ai-icon-btn scraii-ai-chart-btn" matTooltip="Generate Chart"
                                [matTooltipPosition]="'below'" *ngIf="hasChartData(msg) && 1+2 == 5"
                                [disabled]="isGeneratingChart || isLoading || (isTyping && typingMessageIndex === i) || isExecutingQuery"
                                (click)="generateChart(i)">
                                📊
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="isLoading && !hasActiveOpsPlaceholder()" class="scraii-ai-processing-status">
                <div class="scraii-ai-typing-indicator">
                    <span></span><span></span><span></span>
                </div>
                <p *ngIf="processingStatusMessage" class="scraii-ai-status-message-text">
                    {{ processingStatusMessage }}
                </p>
            </div>
        </div>

        <div class="scraii-ai-bottom-input-area" *ngIf="messages.length > 0 && !isLoadingMessages">
            <!-- Top row: browse icon + textarea side by side -->
            <div class="scraii-ai-input-top-row">
                <!-- Browse Queries: icon button + popup anchored to the input bar -->
                <div class="scraii-ai-query-popup-wrapper">
                <button type="button" class="scraii-ai-query-icon-btn"
                    [class.scraii-ai-query-icon-btn-open]="isQueryPopupOpen" matTooltip="Browse Queries" [matTooltipPosition]="'above'" (click)="toggleQueryPopup($event)"
                    aria-label="Browse sample queries">
                    <!-- <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg> -->

                    <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
                        <rect x="3" y="3" width="18" height="18" rx="4" stroke="#6b7280" stroke-width="1.6" />
                        <path d="M8 9h8M8 12.5h5" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" />
                        <circle cx="16.5" cy="16.5" r="3" fill="#6b7280" />
                        <path d="M15.5 16.5h2M16.5 15.5v2" stroke="#fff" stroke-width="1.2" stroke-linecap="round" />
                    </svg>
                </button>

                <!-- Popup with tabbed query lists -->
                <div class="scraii-ai-query-popup" *ngIf="isQueryPopupOpen" (click)="$event.stopPropagation()"
                    role="dialog" aria-label="Browse sample queries">
                    <div class="scraii-ai-popup-tabs">
                        <button type="button" class="scraii-ai-popup-tab"
                            [class.scraii-ai-popup-tab-active]="activeQueryTab === 'dispense'"
                            (click)="switchQueryTab('dispense')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                            Dispense Queries
                        </button>
                        <button type="button" class="scraii-ai-popup-tab"
                            [class.scraii-ai-popup-tab-active]="activeQueryTab === 'status'"
                            (click)="switchQueryTab('status')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                            </svg>
                            Status Queries
                        </button>
                        <button type="button" class="scraii-ai-popup-tab"
                            [class.scraii-ai-popup-tab-active]="activeQueryTab === 'journey'"
                            (click)="switchQueryTab('journey')">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                            </svg>
                            Patient Queries
                        </button>
                        <button class="scraii-ai-close-btn-inline" style="background-color: #ffffff;color: #6b7280;"
                            (click)="toggleQueryPopup($event)">&times;</button>
                    </div>
                    <div class="scraii-ai-popup-list">
                        <button type="button" class="scraii-ai-popup-item" *ngFor="let query of getQueriesForTab()"
                            (click)="selectQueryFromPopup(query)">
                            {{ query }}
                        </button>
                    </div>
                </div>
            </div>

                <textarea #bottomTextarea [(ngModel)]="userInput" placeholder="Ask Neo anything about your data." rows="1"
                    class="scraii-ai-chat-textarea"
                    [class.scraii-ai-chat-textarea-floating]="isFloatingView"
                    (keydown.enter)="handleEnterKey($event)" (input)="adjustTextareaHeight($event)"
                    (ngModelChange)="syncActiveTextareaHeight()"
                    [disabled]="isLoading || isGeneratingChart || isExecutingQuery || isAutoExecuting"></textarea>
            </div><!-- /.scraii-ai-input-top-row -->

            <!-- Bottom toolbar: Deep Analysis toggle + send/stop -->
            <div class="scraii-ai-input-toolbar">
                <!-- Deep Analysis toggle pill -->
                <label class="scraii-ai-deep-toggle mb-0"
                    [class.active]="summaryInsightEnabled"
                    [class.scraii-ai-deep-toggle-disabled]="isAnyOperationRunning"
                    [matTooltip]="isAnyOperationRunning ? 'Unavailable while a request is in progress' : 'Generate an AI summary with each response'"
                    [matTooltipPosition]="'above'">
                    <input type="checkbox" [checked]="summaryInsightEnabled"
                        [disabled]="isAnyOperationRunning"
                        (change)="toggleSummaryInsight()" />
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span>Insights Summary</span>
                </label>

                <div class="scraii-ai-input-actions">
                    <button *ngIf="speechSupported" class="scraii-ai-voice-btn"
                        [class.recording]="isRecording$ | async" [disabled]="isAnyOperationRunning"
                        (click)="toggleVoiceInput()"
                        [matTooltip]="(isRecording$ | async) ? 'Stop voice input' : 'Start voice input'"
                        [matTooltipPosition]="'above'">
                        <svg *ngIf="!(isRecording$ | async)" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19 10v2a7 7 0 0 1-14 0v-2M12 19v4M8 23h8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg *ngIf="isRecording$ | async" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <rect x="6" y="6" width="12" height="12" rx="2"/>
                        </svg>
                    </button>
                    <button *ngIf="!isAnyOperationRunning" (click)="sendChatbotMessage()"
                        [disabled]="isLoading || !userInput.trim() || isGeneratingChart || isExecutingQuery || isAutoExecuting"
                        class="scraii-ai-send-btn" [class.scraii-ai-send-btn-pulse]="sendBtnPulse">
                        <!-- ➤ -->
                        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 15V1.5M1 7.5L7 1L13 7.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <button *ngIf="isAnyOperationRunning" (click)="stopCurrentOperation()" class="scraii-ai-stop-btn"
                        matTooltip="Stop current operation" [matTooltipPosition]="'above'">
                        <!-- ⏹ -->
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 0H2C0.89543 0 0 0.89543 0 2V12C0 13.1046 0.89543 14 2 14H12C13.1046 14 14 13.1046 14 12V2C14 0.89543 13.1046 0 12 0Z" fill="white"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <aside class="scraii-ai-sidebar" *ngIf="isExpanded">

        <!-- Sidebar header: "Conversations" title + action icons (reload / new chat / collapse) -->
        <div class="scraii-ai-sidebar-header-new">
            <h3 class="scraii-ai-sidebar-title">Conversations</h3>
            <div class="scraii-ai-sidebar-header-actions">
                <!-- Reload: only when history load previously failed. -->
                <button type="button" class="scraii-ai-sidebar-icon-btn scraii-ai-sidebar-icon-btn--reload"
                    *ngIf="showHistoryRefresh && !isLoadingHistory"
                    (click)="loadChatHistory(); $event.stopPropagation()"
                    matTooltip="Retry loading chats" [matTooltipPosition]="'below'"
                    aria-label="Retry loading chat history">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M1 4v6h6" stroke="currentColor" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>

                <!-- New chat: compact icon replaces the old full-width pill. -->
                <button type="button" class="scraii-ai-sidebar-icon-btn scraii-ai-sidebar-icon-btn--new-chat"
                    (click)="startNewChat(); $event.stopPropagation()"
                    matTooltip="New chat" [matTooltipPosition]="'below'"
                    aria-label="Start a new chat">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M12 5V19M5 12H19" stroke="currentColor"
                            stroke-width="2.5" stroke-linecap="round" />
                    </svg>
                </button>

                <!-- Collapse: same behavior as before, now a dedicated button. -->
                <button type="button" class="scraii-ai-sidebar-icon-btn"
                    (click)="toggleAiChats()"
                    matTooltip="Collapse sidebar" [matTooltipPosition]="'below'"
                    aria-label="Close history panel">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>

        <!-- Always-visible search input (replaces the toggle-gated search). -->
        <div class="scraii-ai-sidebar-search">
            <svg class="scraii-ai-sidebar-search-icon" width="14" height="14" viewBox="0 0 24 24"
                fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path
                    d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <input type="text" [(ngModel)]="searchQuery" (input)="filterChats()"
                placeholder="Search chats..." aria-label="Search chats" />
            <button type="button" *ngIf="searchQuery" (click)="clearSearch()"
                class="scraii-ai-sidebar-search-clear"
                aria-label="Clear search">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            </button>
        </div>

        <!-- Body: scrollable list / loading / empty state. Only this region scrolls. -->
        <div class="scraii-ai-sidebar-body">
            <!-- Loading -->
            <div *ngIf="isLoadingHistory" class="scraii-ai-loading-chats">
                <div class="scraii-ai-typing-indicator">
                    <span></span><span></span><span></span>
                </div>
            </div>

            <!-- Chat list — grouped Today / Yesterday / Earlier. -->
            <!-- Each group renders only when it has chats; empty groups are -->
            <!-- hidden so the sidebar stays tight during search and on sparse -->
            <!-- histories. Timestamps are locale-aware and right-aligned. -->
            <div class="scraii-ai-old-chats-list" *ngIf="!isLoadingHistory">
                <ng-container *ngFor="let group of chatGroups; trackBy: trackGroupByLabel">
                    <div class="scraii-ai-sidebar-group-label">{{ group.label }}</div>

                    <div class="scraii-ai-chat-item-wrapper"
                        *ngFor="let chat of group.chats; trackBy: trackChatByConversationId"
                        [class.scraii-ai-chat-item-active]="chat.conversation_id === activeConversationId">
                        <button class="scraii-ai-chat-item" (click)="loadChat(chat)">
                            <!-- <span style="width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; margin-top: 5px; background:linear-gradient(180deg, #0C1E52, #4D2D8A, #A03090) ;"></span> -->
                            <span class="scraii-ai-chat-title">{{ chat.name }}</span>
                            <span class="scraii-ai-chat-time" *ngIf="chat.created_at" matTooltip="{{ formatChatTimestampFull(chat.created_at) || null }}" matTooltipPosition="right">
                                {{ formatChatTimestamp(chat.created_at) }}
                            </span>
                        </button>

                        <!-- Three-dot menu button with mat-menu trigger -->
                        <button class="scraii-ai-chat-menu-btn" [matMenuTriggerFor]="chatMenu"
                            (click)="$event.stopPropagation()"
                            aria-label="Chat options">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                <circle cx="12" cy="5" r="1.5" fill="currentColor" />
                                <circle cx="12" cy="12" r="1.5" fill="currentColor" />
                                <circle cx="12" cy="19" r="1.5" fill="currentColor" />
                            </svg>
                        </button>

                        <mat-menu #chatMenu="matMenu" xPosition="before" yPosition="below">
                            <button mat-menu-item class="scraii-ai-delete-menu-item"
                                (click)="deleteChat(chat.conversation_id)">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path
                                        d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2m3 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14z"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </div>
                </ng-container>

                <!-- Empty state: differentiates "no matches for your search" vs "no chats at all" -->
                <div *ngIf="filteredOldChats.length === 0" class="scraii-ai-empty-chats">
                    <p>{{ searchQuery ? 'No matches found' : 'No previous conversations' }}</p>
                </div>
            </div>
        </div>
    </aside>

    <!-- Fullscreen ESC hint toast — rendered inside the component so it can layer
         above the fullscreen overlay (z-index: 9999). MatSnackBar renders into
         cdk-overlay-container (z-index: 1102) which sits behind the overlay. -->
    <div class="scraii-ai-fullscreen-toast" *ngIf="fullscreenToastVisible && !isFloatingView"
        [class.scraii-ai-fullscreen-toast-fade-out]="!fullscreenToastVisible">
        To exit full screen, press <strong>ESC</strong>
    </div>
</div>

<!-- Feedback Dialog -->
<div class="scraii-ai-feedback-dialog-overlay" [class.scraii-ai-feedback-dialog-floating]="isFloatingView"
    *ngIf="showFeedbackDialog" (click)="closeFeedbackDialog()">
    <div class="scraii-ai-feedback-dialog" (click)="$event.stopPropagation()">
        <div class="scraii-ai-feedback-dialog-header">
            <h3>Provide Feedback</h3>
            <button class="scraii-ai-close-btn" (click)="closeFeedbackDialog()">&times;</button>
        </div>
        <div class="scraii-ai-feedback-dialog-body">
            <div class="scraii-ai-selected-message-container">
                <span>{{currentselectedMessage}}</span>
            </div>
            <label for="feedbackTextarea">What could be improved?</label>
            <textarea id="feedbackTextarea" [(ngModel)]="feedbackText" required
                placeholder="Please describe what went wrong or suggest a better SQL query..." rows="6"></textarea>
        </div>
        <div class="scraii-ai-feedback-dialog-footer">
            <button class="scraii-ai-btn-cancel" (click)="closeFeedbackDialog()">Cancel</button>
            <button class="scraii-ai-btn-submit" (click)="submitFeedback()">Submit Feedback</button>
        </div>
    </div>
</div>
<!-- Query Execution Confirmation Dialog -->
<div class="scraii-ai-feedback-dialog-overlay" [class.scraii-ai-feedback-dialog-floating]="isFloatingView"
    *ngIf="showQueryDialog" (click)="closeQueryDialog()">
    <div class="scraii-ai-feedback-dialog" (click)="$event.stopPropagation()">
        <div class="scraii-ai-feedback-dialog-header">
            <h3>Execute Query?</h3>
            <button class="scraii-ai-close-btn" (click)="closeQueryDialog()">&times;</button>
        </div>
        <div class="scraii-ai-feedback-dialog-body">
            <p style="margin-bottom: 1rem; color: #374151;">Are you sure you want to execute this SQL query?</p>
            <div class="scraii-ai-query-preview">
                <pre>{{ queryToExecute }}</pre>
            </div>
        </div>
        <div class="scraii-ai-feedback-dialog-footer">
            <button class="scraii-ai-btn-cancel" (click)="closeQueryDialog()">Cancel</button>
            <button class="scraii-ai-btn-submit" (click)="executeQuery()">Execute</button>
        </div>
    </div>
</div>